import { Checkbox, List, ListItemButton, ListItemIcon, ListItemText, Paper } from "@mui/material";
import { useState, useEffect } from "react";

const CheckBoxListInput = ({ enumObject, checkedItems, handleToggle, handleUncheckToggle }) => {
    const [checked, setChecked] = useState(checkedItems || []);

    // Update local checked state when checkedItems prop changes
    useEffect(() => {
        setChecked(checkedItems || []);
    }, [checkedItems]);

    const handleClick = async (key) => {
        if (checked.includes(key)) {
            await handleUncheckToggle(key);
            setChecked(checked.filter(item => item !== key));
        } else {
            await handleToggle(key);
            setChecked([...checked, key]);
        }
    };

    return (
        <Paper sx={{ overflow: 'auto' }}>
            <List dense component="div" role="list">
                {Object.keys(enumObject).map(key => {
                    // Log the values for debugging
                    console.log("Key:", key);
                    console.log("Checked items:", checked);
                    console.log("Condition result:", checked.includes(key)); // Log the result of the includes check


                    return (
                        <ListItemButton
                            key={key}
                            role="listitems"
                            onClick={() => handleClick(Number(key))} // Pass normalized key
                        >
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.includes(Number(key))} // Use normalized key here too
                                />
                            </ListItemIcon>
                            <ListItemText>
                                {enumObject[key]}
                            </ListItemText>
                        </ListItemButton>
                    );
                })}
            </List>
        </Paper>
    );
};

export default CheckBoxListInput;
